import * as Yup from 'yup';

import i18n from '@/i18n';

export const createUpdateUserSchema = (
  addOrganizationId = false,
  addEventId = false,
  deviceIds = false
) =>
  Yup.object().shape({
    firstName: Yup.string()
      .required(i18n.t('firstNameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    lastName: Yup.string()
      .required(i18n.t('lastNameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    email: Yup.string()
      .required(i18n.t('emailRequired', { ns: 'common' }))
      .email(i18n.t('emailInvalid', { ns: 'common' })),
    roleId: Yup.string().required(i18n.t('roleRequired', { ns: 'common' })),
    ...(addOrganizationId && {
      organizationIds: Yup.array()
        .min(1, i18n.t('organizationRequired', { ns: 'common' }))
        .required(i18n.t('organizationRequired', { ns: 'common' }))
    }),
    eventId: addEventId
      ? Yup.string().required(i18n.t('eventRequired', { ns: 'common' }))
      : Yup.string(),
    deviceIds: deviceIds
      ? Yup.array()
          .min(1, i18n.t('deviceRequired', { ns: 'common' }))
          .required(i18n.t('deviceRequired', { ns: 'common' }))
      : Yup.array()
  });

export const updateUploaderSchema = Yup.object().shape({
  firstName: Yup.string()
    .required(i18n.t('firstNameRequired', { ns: 'common' }))
    .min(2, i18n.t('nameMin', { ns: 'common' }))
    .max(35, i18n.t('nameMax', { ns: 'common' })),
  lastName: Yup.string()
    .required(i18n.t('lastNameRequired', { ns: 'common' }))
    .min(2, i18n.t('nameMin', { ns: 'common' }))
    .max(35, i18n.t('nameMax', { ns: 'common' }))
});
